import seriveFactory from './service';
import { Notification } from 'element-ui';
import baseUrl from './baseUrl';

const API = seriveFactory({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json', // application/x-www-form-urlencoded , multipart/form-data
    sysId: window._env_.VUE_APP_SYSID
  }
}, function (json, error) {
  Notification.error({
    message: json.error || json.err || '请求服务器失败'
  });
});
export default API;
